import {FETCH_ENTRY_SUCCESS, FETCH_ENTRY_REQUEST, FETCH_ENTRY_FAILURE} from './sEntryTypes'

const initialState = {
  loading: true,
  data: [],
  errorMsg: '',
};


const entryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ENTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ENTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: '',
      };
    case FETCH_ENTRY_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default entryReducer